import { api, getWithOptionalAuthorizationGeneric } from './api';
import { ROUT_BASE } from './apiConstant';
import { getToken } from './auth';
import { decryptMessage } from '../utils/decrypt';

export type RouteResponse = {
  id: string;
  tripName: string;
  fileName: string;
  fileUrl: string;
  mobileFileUrl: string;
  createdAt: string;
  direction: number;
  description: string;
};


const routApi = {

  getRouteByTripId : async (tripID: string): Promise<RouteResponse> => {
    try {
      const encryptedContestResponse = await getWithOptionalAuthorizationGeneric<RouteResponse[]>(`${ROUT_BASE}/GetAll/${tripID}`, true);
      const tripManagementResponse = await decryptMessage(encryptedContestResponse.data.Data, getToken());
      return tripManagementResponse;
    } catch (error) {
      console.error('Error fetching trip management:', error);
      throw error;
    }
  }
};

export default routApi;